import { useGlobal } from 'raducer/global'

// Returns the global-settings province only when the listing plan is DDF,
// so callers can pass it as `pv` to listing APIs; otherwise undefined.
const useListingProvince = (): string | undefined => {
 const { global } = useGlobal()
 return global?.listing_plan === 'DDF' && global?.province
  ? global.province
  : undefined
}

export default useListingProvince
